// extracted by mini-css-extract-plugin
export default {"date":"DateContent_date__3mKPX"};